// Read the rendered article so Markdown/HTML formatting never enters the clipboard.
export function sermonBodyText(element) {
  if (!element) return '';
  const copy = element.cloneNode(true);
  copy.querySelectorAll('h1, img, picture, figure, video, audio, iframe, script, style, time, button, .author-inline, .sermon-sien-after-sources, [data-sermon-support], .youtube-thumbnail-link').forEach((node) => node.remove());
  copy.querySelectorAll('p').forEach((node) => {
    if (/^(?:公開日|投稿日|更新日)?\s*[:：]?\s*\d{4}(?:[-/]\d{1,2}[-/]\d{1,2}|年\d{1,2}月\d{1,2}日)$/.test(node.textContent.trim())) node.remove();
  });
  const blockTags = new Set(['P', 'DIV', 'SECTION', 'H2', 'H3', 'H4', 'H5', 'H6', 'BLOCKQUOTE', 'UL', 'OL', 'LI', 'PRE', 'TR']);
  function read(node) {
    if (node.nodeType === 3) return node.textContent;
    if (node.nodeName === 'BR') return '\n';
    const text = Array.from(node.childNodes).map(read).join('');
    if (node.nodeName === 'TD' || node.nodeName === 'TH') return `${text}\t`;
    return blockTags.has(node.nodeName) ? `\n\n${text}\n\n` : text;
  }
  return read(copy).replace(/[ \t]+\n/g, '\n').replace(/\n[ \t]+/g, '\n').replace(/\n{3,}/g, '\n\n').trim();
}

export async function copySermonBody(element) {
  const text = sermonBodyText(element);
  if (!text) throw new Error('本文がありません');
  if (navigator.clipboard?.writeText) {
    await navigator.clipboard.writeText(text);
    return;
  }
  const field = document.createElement('textarea');
  field.value = text;
  field.style.position = 'fixed';
  field.style.opacity = '0';
  field.setAttribute('readonly', '');
  const focused = document.activeElement;
  document.body.appendChild(field);
  try {
    field.select();
    if (!document.execCommand('copy')) throw new Error('コピーできませんでした');
  } finally {
    field.remove();
    focused?.focus();
  }
}
